import { FadeUp } from "@/components/Reveal";

const POINTS = [
  { title: "Advanced Technology", text: "Access to sophisticated compute and enterprise hardware requirements." },
  { title: "Global Sourcing", text: "International sourcing across multiple technology categories." },
  { title: "B2B Execution", text: "Structured commercial handling for resellers, businesses, integrators and institutional buyers." },
  { title: "UAE Base", text: "Strategically positioned in the UAE for regional and international trade." },
];

export const WhyUs = () => (
  <section className="relative py-20 lg:py-24 bg-[#FAFAFA] border-y border-midnight/10" data-testid="why-section">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
      <FadeUp className="max-w-2xl">
        <h2 className="font-heading text-3xl md:text-4xl font-medium tracking-tight text-midnight">
          Why Royal Deals FZ-LLC
        </h2>
      </FadeUp>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-x-8 gap-y-10 mt-12">
        {POINTS.map((p, i) => (
          <FadeUp key={p.title} delay={i * 0.07}>
            <div className="border-t-2 border-gold/60 pt-5" data-testid={`why-${p.title.toLowerCase().replace(/\s+/g, "-")}`}>
              <p className="font-heading font-medium text-midnight mb-2">{p.title}</p>
              <p className="text-sm text-midnight/55 leading-relaxed">{p.text}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
